import { Tab, TabProps, Tabs, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { Link as RouterLink, Outlet, useNavigate } from "react-router-dom"
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Car as CarModel, CarSchema } from "../../../../models/car";
import { getCarById } from "../../api/cars.service";
import { CarProvider } from "@features/tickets/contexts/CarContext";
import { useErrorBoundary } from "react-error-boundary";
import { handleErrorWithBoundary } from "@shared/lib/errors"
import { useTheme } from "@emotion/react";


interface LinkTabProps extends TabProps {
  path: string;
  selected?: string;
}

function LinkTab(props: LinkTabProps) {
  return (
    <Tab
      component={RouterLink}
      to={props.path}
      label={props.label}
      aria-current={props.selected ? 'page' : undefined}
      {...props}
    />
  );
}

// Define an array of tab hrefs
const tabsData = [
  {
    label: "פרטי רכב",
    path: "",
  },
  {
    label: "תנועות",
    path: "journal-entries",
  },
];


function Car() {

  const theme = useTheme();
  const { showBoundary } = useErrorBoundary();
  const location = useLocation();
  const navigate = useNavigate();

  const currentIndex = tabsData.findIndex(tab => tab.path !== "" && location.pathname.includes(tab.path));
  const value = currentIndex !== -1 ? currentIndex : 0;

 
  const [car, setCar] = useState<CarModel | undefined>();
  const { id } = useParams();


  useEffect(() => {
    if(location.state){
      setCar(location.state);
      navigate(location.pathname, { replace: true, state: null });
    }

    else{
      getCar();
    }
  }, []);

  const getCar = async () => {
    try {
      if (id) {
        const car = await getCarById(id);
        const carParse = CarSchema.parse(car);
        setCar(carParse);
      }
    } catch (error) {
      handleErrorWithBoundary(error, showBoundary);
    }
  }

  {
    return car && 
    <>
      <div>
        <Typography variant="h5" component="span">
          כרטיס רכב
        </Typography>

        {/* <span>מס כרטיס: {item?.card_number}</span> */}
        <span>מס כרטיס: {car?.id}</span>
      </div>

      <Tabs
        dir='ltr'
        value={value}
        role="navigation"
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        style={{ direction: "rtl", flexDirection: "row-reverse", backgroundColor: theme.colors.section_color, padding: 5, marginTop: 20 }}

      >
        {tabsData.map((tab, index) => (
          <LinkTab key={index} label={tab.label} path={tab.path} />
        ))}

      </Tabs>
      <CarProvider car={car}>
        <Outlet />
      </CarProvider>
    </>
  }
}

export default Car